import { useCallback, useState } from 'react';
import { useApi } from '#shared/providers/Api';
import useUsers from './useUsers';
import unwrap from './unwrap';
import { UserRow } from './types';

// The user list and its fetch. Rejects on failure so the caller decides how to surface it.
export default function useUsersList() {
  const api = useApi();
  const { viewer, account } = useUsers();
  const [users, setUsers] = useState<UserRow[]>([]);
  const [fetching, setFetching] = useState(false);

  const fetchUsers = useCallback(async () => {
    try {
      setFetching(true);
      const res = await unwrap(api.fetchAccountUsers({ Timezone: viewer.timezone }, account.bearer));
      setUsers(res.Users);
    } finally {
      setFetching(false);
    }
  }, [api, viewer.timezone, account.bearer]);

  return { users, fetching, fetchUsers };
}
